export const queriesUrlRegex = /^https?:\/.*\/.*\/.*\/_queries\/query/gm;
export const tokyoUrlRegex =
  /^https?:\/.*\/.*\/.*\/(vss-data|stp-data|stm-data).*/gm;

export enum VariableAccessLevel {
  Local = 'Local',
  General = 'General',
}
